// EN
export const calendarHotel = {
  btn: {
    today: "Oggi",
  },
  summary: {
    availableLabel: "Disponibili",
  },
  tooltip: {
    closed: "Chiuso",
    dragToCreate: "Trascina per selezionare (crea prenotazione)",
  },
  labels: {
    room: "camera",
    rooms: "camere",
    number: "NUMERO:",
    capacityIconAlt: "Capacità",
    maintenanceBadge: "MANUT.",
  },
  toasts: {
    reservationCreatedOk: "Prenotazione creata correttamente.",
    reservationCreateErrPrefix: "Impossibile creare la prenotazione: ",
    roomChangedOk: "Camera cambiata correttamente",
    roomChangedErr: "Errore durante il cambio della camera",
    roomTypeChangedOk: "La prenotazione passa a {type}",
  },
  warn: {
    selectTwoDays: "Seleziona almeno due giorni (check-in e check-out).",
  },
  errors: {
    closedForBooking: "Non puoi prenotare una camera o uno slot chiuso.",
    noAvailabilityTitle: "Nessuna disponibilità",
    noAvailabilityDetail: "Non ci sono camere disponibili di quel tipo in quelle date.",
    noRatesTitle: "Nessuna tariffa assegnata",
    noRatesDetail: "Non ci sono tariffe disponibili per quel tipo in quelle date.",
    missingDataTitle: "Dati mancanti",
    missingDataDetail: "Compila tutti i campi obbligatori.",
  },
  maintenanceModal: {
    titleFallback: "Camera",
    statusSection: "Stato",
    closeForMaintenance: "Chiudi per manutenzione",
    open: "Apri",
    hint:
      "Quando una camera è in manutenzione, non può essere venduta e le sue celle appariranno in rosso. Le prenotazioni esistenti vengono rispettate.",
    actions: {
      cancel: "Annulla",
      save: "Salva",
      saving: "Salvataggio…",
    },
  },

  // ===== NEW: Reservation modal =====
  modal: {
    title: "Registra nuova prenotazione",
    startDate: "Check-in",
    endDate: "Check-out",
    roomType: "Tipo di camera",
    roomTypePlaceholder: "Seleziona il tipo",
    quantity: "Numero di camere",
    available: "disponibili",
    guestName: "Ospite responsabile",
    guestNamePlaceholder: "Persona responsabile della prenotazione",
    guests: "Numero di ospiti",
    guestsPlaceholder: "Numero di ospiti",
    phone: "Telefono",
    email: "Email",
    notes: "Nota",
    notesPlaceholder: "Note interne sulla prenotazione (es. arrivo in ritardo, culla, allergie…)",
    addType: "Aggiungi un altro tipo di camera",
    price: "Prezzo",
    pricePlaceholder: "Inserisci il prezzo",
    cancel: "Annulla",
    create: "Crea prenotazione",
  },

  // ===== Validations =====
  validation: {
    minGuestsTitle: "Ospiti insufficienti",
    minGuestsDetail: "Sono necessari almeno {min} ospiti per {rooms} camere.",
    maxGuestsTitle: "Limite di ospiti superato",
    maxGuestsDetail: "Massimo {maxPerRoom} ospiti per camera ({maxTotal} in totale per {rooms} camere).",
    maxRoomsTitle: "Limite superato",
    maxRoomsDetail: "Non puoi prenotare più di {max} camere.",
  },

  // ===== Promotions & Taxes =====
  promotions: {
    limitTitle: "Limite raggiunto",
    limitDetail: "Non puoi aggiungere più di 1 promozione.",
  },
  taxes: {
    limitTitle: "Limite raggiunto",
    limitDetail: "Non puoi aggiungere più di 1 imposta.",
  },
};
